export default "__VITE_ASSET__CdUcw7rP__"